import { Document, Page } from "react-pdf"
import { useCallback, useMemo, useState } from "react"
import PDFUrl from "./test_invoice.pdf"
import { Box, Card, Typography } from "@mui/material"
import "react-pdf/dist/esm/Page/TextLayer.css"
import "react-pdf/dist/esm/Page/AnnotationLayer.css"
import "./Sample.css"
import { useResizeObserver } from "@wojtekmaj/react-hooks"
import { PDFErrorDisplay } from "./PDFViewer.styles"

const resizeObserverOptions = {}

const maxWidth = 1000

export interface Props {
  url: string
  renderPdfInline: boolean
}

export default function PDFViewer(props: Props) {
  const [numPages, setNumPages] = useState<number>()
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null)
  const [containerWidth, setContainerWidth] = useState<number>()

  const mode = import.meta.env.MODE

  let url = props.url
  if (mode === "development") {
    url = PDFUrl
    console.log("Running in development mode, using a test url for PDF display")
  }

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries

    if (entry) {
      setContainerWidth(entry.contentRect.width)
    }
  }, [])

  useResizeObserver(containerRef, resizeObserverOptions, onResize)

  function onDocumentLoadSuccess({ numPages }: { numPages: number }): void {
    setNumPages(numPages)
  }

  return (
    <Box>
      {props.renderPdfInline && (
        <div className="Example__container__document">
          <Document file={url} onLoadSuccess={onDocumentLoadSuccess}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={
                  containerWidth ? Math.min(containerWidth, maxWidth) : maxWidth
                }
              />
            ))}
          </Document>
        </div>
      )}
      {!props.renderPdfInline && (
        <PDFErrorDisplay>
          <Typography>
            Large invoice detected, use controls above to download and view the
            invoice PDF.
          </Typography>
        </PDFErrorDisplay>
      )}
    </Box>
  )
}
